import DOMPurify from "dompurify";

const escapeHtml = (value) =>
  String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

// Consent text is admin-authored rich text rendered raw into an embed that runs
// on third-party sites — sanitize to a safe allowlist to prevent stored XSS.
const CONSENT_ALLOWED_TAGS = ["b", "strong", "i", "em", "u", "a", "br"];
const CONSENT_ALLOWED_ATTR = ["href", "target", "rel"];

export const sanitizeConsentHtml = (value) => {
  const clean = DOMPurify.sanitize(String(value == null ? "" : value), {
    ALLOWED_TAGS: CONSENT_ALLOWED_TAGS,
    ALLOWED_ATTR: CONSENT_ALLOWED_ATTR,
  });

  // Harden links locally, not via a global DOMPurify hook that would affect every other caller.
  const template = document.createElement("template");
  template.innerHTML = clean;
  template.content.querySelectorAll("a[href]").forEach((a) => {
    a.setAttribute("target", "_blank");
    a.setAttribute("rel", "noopener noreferrer nofollow");
  });
  return template.innerHTML;
};

export const buildSignupFormEmbed = (form, { embedBaseUrl = "" } = {}) => {
  const iframeId = escapeHtml(`od-signup-form-${form.uuid}`);
  const title = escapeHtml(form.config?.text?.heading || "Sign up");

  return `<script src="${escapeHtml(embedBaseUrl)}/packs/od_signup_form_embed.js"></script>
<iframe src="${escapeHtml(`${embedBaseUrl}${form.public_path}`)}" id="${iframeId}" title="${title}" scrolling="no" style="border:none; width:1px; min-width:100%;" height="600"></iframe>
<script>
  ODSignupFormEmbed("${iframeId}");
</script>`;
};

export default buildSignupFormEmbed;
